import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { retryWhen, mergeMap } from 'rxjs/operators';

export interface RetryParams {
  maxAttempts?: number;
  retry?: (error: HttpErrorResponse) => boolean;
}

export const GENERATE_PIN = new HttpContextToken(() => false);

// Maximalni pocet pokusu je implicitne 5 + status 429. Tento retryInterceptor pujde ale pouzit klidne na odchyceni i ostatnich veci
const defaultRetrySettings: Required<RetryParams> = {
  maxAttempts: 5,
  retry: ({ status }) => status === 429,
};

export const retryStrategy =
  (params: RetryParams = {}) =>
  (attempts: Observable<HttpErrorResponse>) =>
    attempts.pipe(
      mergeMap((error, i) => {
        const maxAttempts = params.maxAttempts ?? defaultRetrySettings.maxAttempts;
        const retry = params.retry ?? defaultRetrySettings.retry;
        const retryAttempt = i + 1;
        if (retryAttempt > maxAttempts || !retry(error)) {
          return throwError(() => error);
        }
        const retryAfterSeconds = Number(error.error?.retryAfter ?? 0);
        return timer(retryAfterSeconds * 1000);
      })
    );

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.context.get(GENERATE_PIN) === true) {
      return next.handle(req);
    }
    return next.handle(req).pipe(retryWhen(retryStrategy()));
  }
}
